/*
 *   File : nfo-card.js
 *   Author : https://evoqins.com
 *   Description : NFO card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';


function NFOCard({ data, handleClick }) {
    return (
        <div className="e-border-1px-platinum e-border-radius-20 p-2 p-sm-3 h-100 cursor-pointer card-hover e-bg-white" onClick={handleClick}>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <img
                    src={data.image}
                    alt="Bank"
                    draggable="false"
                    className='w-40px width-32px-res e-border-radius-8 e-bg-white'
                />
                <span className="e-border-1px-water-blue  py-sm-2 padding-12px-lr e-text-egyptian-blue padding-8px-all-res e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-400  e-border-radius-20 e-bg-alice-blue">
                    NFO
                </span>
            </div>
            <p className="e-text-onyx e-font-14-res e-font-16 e-font-weight-500 e-alt-font-poppins mb-3 e-ellipse">
                {data.fund_name}
            </p>
            <p className="e-text-html-css-gray e-font-12 e-font-weight-400 e-alt-font-poppins mb-0">
                End date: <span className='e-text-eerie-black e-font-weight-500'>{data.nfo_end_date || '-'}</span>
            </p>
        </div>
    )
}

export default NFOCard;